import {
  Card,
  CardActions,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import { FC } from "react";
import { Link, useParams } from "react-router-dom";
import { IProductOffering } from "../../types/order";
import { formatProductName } from "../../utils/product";
import AmountButton from "./AmountButton";

const formatPrice = (price: string) => `R$ ${price.replace(".", ",")}`;

const API = process.env.REACT_APP_API;

interface Props {
  product: IProductOffering;
}

const Product: FC<Props> = ({ product }) => {
  const { slug } = useParams();
  const productLink = slug ? `/${slug}/produto/${product.id}` : "";
  const productName = formatProductName(product.product);

  return (
    <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
        }}
      >
        <CardActionArea
          component={Link}
          to={productLink}
          sx={{ flex: "1 0 auto" }}
        >
          <CardMedia
            image={
              product.product.image ? API + product.product.image : undefined
            }
            sx={{ height: "10rem" }}
            title={productName + " - " + product.product.producer.name}
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" component="h3">
                  {productName} - {product.product.producer.name}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {formatPrice(product.price)}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <AmountButton product={product} />
        </CardActions>
      </Card>
    </Grid>
  );
};

export default Product;
